import { UserSessionDataForm } from "./login/user-session-data-form";
import { SessionActivityDataForm } from "./session-activity-data-form";
import { ProjectDataForm } from "./project-data-form";

export class BasicInventionDetailsDataForm {
	inventionName: string;
	inventionPublishStatus: string;
	// inventionPublishDetails?: string[];
	inventionPublishDetails: string;
	inventionCategory: string;
	inventionCategoryOthers: string;
	inventionProgress: string;
	inventionType: string;
	inventionTechCategory: string;
	inventionTechCategoryOthers: string;
	inventionProbSolution: string;
	inventionDescription: string;
	inventionComponents: string;
	inventionAdvantages: string;
	inventionDrawingStatus: string;
	
	basicInventionDetailsId: number;
	userSessionDataForm: UserSessionDataForm;
	sessionActivityDataForm : SessionActivityDataForm;
	projectDataForm : ProjectDataForm;
}
